import React from "react";

import Avatar from "../Avatar";
import * as Styled from "./User.styled";

const User = ({ name, image, icon, roleName }) => {
  return (
    <Styled.User>
      <Styled.Image>{image ? <Avatar name={name} picture={image} /> : icon}</Styled.Image>
      <Styled.Text placeholder={!image}>
        {name} <span>{roleName}</span>
      </Styled.Text>
    </Styled.User>
  );
};

export default User;
